// JsFromRoutes CacheKey 2a256420710697a9f23bc786fec82084
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/my-account/wishlists'),
  show: /* #__PURE__ */ definePathHelper('get', '/my-account/wishlists/:id'),
}
